import type { JSX } from 'react'

export const TrueIdLogoIcon = (): JSX.Element => (
  <use href='#trueIdLogoIcon' height='100%' width='100%' />
)
